// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"P2-z","displaySixCardTiles":"Q2-z"};